export default class EventList  {
    constructor($view) {
        this.$view = $view;
        this.defaultHtml = $view.find('.event-blocks').html();
        this.bind();
    }

    bind() {
        this.$view.on('click','.date-badge',(e) => {
            e.preventDefault();
            this.$view.find('.event-blocks').html(this.defaultHtml);
        });
    }

}